import { createSelector } from "reselect";
import get from "lodash/get";

const serviceStatusRequestFormDomain = state =>
  get(state, "form.ManualEkycForm.values", {});

// ***************************************************************
// ************ ServiceStatusRequestForm selectors ***************
// ***************************************************************
export const serviceStatusRequestFormSelector = createSelector(
  serviceStatusRequestFormDomain,
  serviceStatusRequestForm => serviceStatusRequestForm
);

// ***************************************************************
// ************ ServiceStatusRequestForm makeSelect **************
// ***************************************************************
export const makeSelectServiceStatusRequestForm = () =>
  serviceStatusRequestFormSelector;
